import { useQuery } from '@tanstack/react-query';

import type { MultiProcessOfferDto } from '@/api/generated';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = { multiOfferId?: string; processId?: string };

type Return = {
  isGetting: boolean;
  processMultiOffer: MultiProcessOfferDto | undefined;
};

export const useGetProcessMultiOffer = (req: Req): Return => {
  const { processMultiOffersApi } = useProcessApiClient();
  const { userId } = useUserContext();
  const enabled = !!req.multiOfferId && !!req.processId;

  const { data, isPending } = useQuery<MultiProcessOfferDto | undefined>({
    enabled,
    queryFn: async () => {
      if (!req.multiOfferId || !req.processId) {
        return undefined;
      }
      const { data } = await processMultiOffersApi.getMultiProcessOfferById(
        userId,
        req.processId,
        req.multiOfferId,
      );
      return data;
    },
    queryKey: [QueryKeyEnum.PROCESS.MULTI_OFFER_DETAILS, req.multiOfferId],
  });

  return {
    isGetting: isPending && enabled,
    processMultiOffer: data,
  };
};
